import { Component, Input, OnInit } from '@angular/core';
import { faCheck, faTimes, faDownload, faHourglassHalf } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-solicitud-timeline',
  templateUrl: './solicitud-timeline.component.html',
  styleUrls: ['./solicitud-timeline.component.scss']
})
export class SolicitudTimelineComponent implements OnInit {
  @Input() date;
  @Input() state;
  @Input() stateDate;
  @Input() hrState;
  @Input() dualState;
  @Input() bagState;
  @Input() hrDate;
  @Input() dualDate;
  @Input() bagStateDate;
  @Input() type;

  milestones = [];
  iconSelect = {};
  faCheck = faCheck;
  faTimes = faTimes;
  faHourglassHalf = faHourglassHalf;
  faDownload = faDownload;

  constructor() { }

  ngOnInit(): void {
    this.milestones = [
      { key: 'Solicitud', state: 'Aprobado', date: this.formatDate(this.date) },
    ];



    if (this.bagState) {
      this.milestones.splice(2, 0, { key: 'Validación bolsa', state: this.bagState, date: this.formatDate(this.bagStateDate) });
    }



    if (this.type != 'Cambio de datos' && this.type != 'Anticipo' && !this.bagState) {
      this.milestones.splice(2, 0, { key: 'Validación mando', state: this.state, date: this.formatDate(this.stateDate) });
      this.milestones.splice(2, 0, { key: 'Validación RRHH', state: this.hrState, date: this.formatDate(this.hrDate) });
    }

    if (this.type === 'Cambio de datos') {
      this.milestones.splice(2, 0, { key: 'Validación RRHH', state: this.hrState, date: this.formatDate(this.hrDate) });
    }

    if (this.type === 'Anticipo') {
      this.milestones.splice(2, 0, { key: 'Validación Ainticipos', state: this.hrState, date: this.formatDate(this.hrDate) });
    }

    if (this.dualState && (this.type != 'Cambio de datos' && this.type != 'Anticipo')) {
      this.milestones.splice(2, 0, { key: 'Validación doble mando', state: this.dualState, date: this.formatDate(this.dualDate) });
    }

    this.iconSelect = {
      "Pendiente": "hourglass",
      "Aprobado": "check",
      "Rechazado": "xmark",
    };
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';

    const date = new Date(this.adjustTimeToSystemTimezone(dateStr).iso);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Los meses comienzan desde 0
    const year = date.getFullYear().toString().slice(-2); // Obtener los últimos 2 dígitos del año
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  getTimelineClass(state: string): string {
    const baseClass = state === 'Pendiente' ? 'timeline-line-dotted-' : 'timeline-line-';
    return baseClass + this.milestones.length;
  }

  adjustTimeToSystemTimezone(dateString: string): { iso: string, date: string, time: string } {
    const localDate = new Date(dateString);
    const timezoneOffset = localDate.getTimezoneOffset() * 60000; // Obtener el offset en milisegundos
    const adjustedTime = new Date(localDate.getTime() - timezoneOffset); // Ajustar a la hora del sistema
    const isoString = new Date(adjustedTime).toISOString(); // Ajustar la hora y obtener la cadena ISO correcta
    const datePart = adjustedTime.toLocaleDateString(); // Formato dd/mm/aaaa
    const timePart = adjustedTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); // Formato hh:mm

    return {
      iso: isoString,
      date: datePart,
      time: timePart
    };
  }
}
